import ModalController from './modal_controller'

export default class ConfirmModalController extends ModalController {
  static targets = ['content', 'container', 'header', 'message', 'confirmButton']

  prepareToShow(event) {
    const button = $(this.findButton(event.target))
    const header = button.data('header')
    const message = button.data('message')
    const action_uri = button.data('action-uri')
    $(this.headerTarget).text(header)

    if (message)
      $(this.messageTarget).html(message)
    $(this.confirmButtonTarget).on('click', function() {
      window.location.href = action_uri
    })
    this.show(event)
  }

  findButton(current) {
    while (current.tagName.toUpperCase() !== 'BUTTON' && current.tagName.toUpperCase() !== 'SPAN' ) {
      current = current.parentElement
      if (current.tagName.toUpperCase() === 'BODY')
        throw new Error('clicked button not found')
    }
    return current
  }
}
